import React from 'react';
import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { playAudio } from '../../../Utils/AudioUtils';
import { t } from '../../../i18n';

interface SitOutOptionsComponentProps {
    playerId: string;
    willSitOutNextHandPlayers: string[] | Set<string> | null | undefined;
    onSitOutOptionChange: (isSitOut: boolean) => void;
    isSatOut?: boolean;
    roomType: 'texas' | 'aof' | string;
    willSitOutNextBbPlayers: string[] | Set<string> | null | undefined;
    onSitOutBbOptionChange: (isSitOut: boolean) => void;
}

const SitOutOptionsComponent: React.FC<SitOutOptionsComponentProps> = ({
    playerId,
    willSitOutNextHandPlayers,
    onSitOutOptionChange,
    isSatOut,
    roomType,
    willSitOutNextBbPlayers,
    onSitOutBbOptionChange,
}) => {
    if (isSatOut) {
        return null;
    }

    const willSitOutNextHand = willSitOutNextHandPlayers ? 
        (Array.isArray(willSitOutNextHandPlayers) 
            ? willSitOutNextHandPlayers.includes(playerId)
            : willSitOutNextHandPlayers.has(playerId)) 
        : false;

    const willSitOutNextBb = willSitOutNextBbPlayers ? 
        (Array.isArray(willSitOutNextBbPlayers) 
            ? willSitOutNextBbPlayers.includes(playerId)
            : willSitOutNextBbPlayers.has(playerId)) 
        : false;

    const handleSitOutChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onSitOutOptionChange(event.target.checked);
        playAudio('pop.mp3');
    };

    const handleSitOutBbChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onSitOutBbOptionChange(event.target.checked);
        playAudio('pop.mp3');
    };

    return (
        <Box>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={willSitOutNextHand}
                            onChange={handleSitOutChange}
                            sx={{ 
                                color: '#9eb0c5',
                                padding: '5px 9px',
                                '&.Mui-checked': {
                                    color: '#ffffff'
                                }
                            }}
                        />
                    }
                    label={t('GameRoom:sitOutOptions.sitOutNextHand')}
                    sx={{ 
                        color: '#fff',
                        '& .MuiFormControlLabel-label': {
                            fontSize: '12px',
                            fontFamily: '"Inter", serif',
                            fontWeight: 600
                        }
                    }}
                />
                {roomType === 'texas' && (
                    <FormControlLabel
                        control={
                            <Checkbox 
                                checked={willSitOutNextBb}
                                onChange={handleSitOutBbChange}
                                sx={{ 
                                    color: '#9eb0c5',
                                    padding: '5px 9px',
                                    '&.Mui-checked': {
                                        color: '#ffffff'
                                    }
                                }}
                            />
                        }
                        label={t('GameRoom:sitOutOptions.sitOutNextBB')}
                        sx={{ 
                            color: '#fff',
                            '& .MuiFormControlLabel-label': {
                                fontSize: '12px',
                                fontFamily: '"Inter", serif',
                                fontWeight: 600
                            }
                        }}
                    />
                )}
            </FormGroup>
        </Box>
    );
};

export default SitOutOptionsComponent; 